import { DateTime } from 'luxon';
export var shiftLocksBeforeStartTime = function (scheduleShift, dropOpportunity) {
    if (!dropOpportunity || !dropOpportunity.addDeadline) {
        return false;
    }
    var dropDeadline = DateTime.fromISO(dropOpportunity.addDeadline);
    var shiftStart = DateTime.fromISO(scheduleShift.shift.timeRange.start);
    return dropDeadline < shiftStart;
};
